export default __webpack_public_path__ + "static/media/xbox.3e7db735.svg";